export default {
    root: {
        class: [
            // Font
            'tw-text-base tw-font-light tw-leading-none',
            'tw-list-none',
        ],
    },
    list: {
        class: [
            // Flex & Alignments
            'tw-flex tw-items-center tw-flex-wrap tw-gap-y-1',
            // Spacing
            'tw-m-0 tw-p-0',
        ],
    },
    item: {
        class: [
            // Color
            'tw-text-zinc-800 dark:tw-text-white/80',
        ],
    },
    itemLink: {
        class: [
            // Flex & Alignments
            'tw-flex tw-items-center tw-gap-2',
            // Shape
            'tw-rounded-md',
            // Color
            'tw-text-gray-600 hover:tw-text-primary-700 dark:tw-text-white/70',
            // States
            'focus-visible:tw-outline-none focus-visible:tw-outline-offset-0',
            'focus-visible:tw-ring focus-visible:tw-ring-primary-400/50 dark:focus-visible:tw-ring-primary-300/50',
            // Transitions
            'tw-transition-shadow tw-duration-200',
            // Misc
            'tw-text-decoration-none',
        ],
    },
    separator: {
        class: [
            // Flex & Alignment
            'tw-flex tw-items-center',
            // Spacing
            'tw-mx-2',
            // Color
            'tw-text-gray-600 dark:tw-text-white/70',
        ],
    },
};
